import React, { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";

import { useTranslation } from "react-i18next";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import moment from "moment";
import smalLogo from "../../assets/images/ElmanagerLogo.png";
import Swal from "sweetalert2";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import OrgContext from "../../organisation/OrgContext";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { Link, useNavigate } from "react-router-dom";
import { AccountCircle } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getEcEco,
  getEcEcoV2,
  getEcFinV2,
} from "../../helpers/EcritureComptableHeper";
import {
  getBqAccountTotal,
  getGlPc,
  getTotalOfAccount,
} from "../../helpers/PCHelper";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
// import { PDFDownloadLink } from '@react-pdf/renderer';

import { frFR, enUS } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import {
  exportGlCsv,
  exportCsv,
  exportBalanceAccountsCsv,
} from "../../helpers/ExportCsvHelper";
import useAuthHelper from "../../helpers/AuthHelper";
import {
  CLASS_1_PC_TYPE,
  CLASS_2_PC_TYPE,
  CLASS_3_PC_TYPE,
  CLASS_4_PC_TYPE,
  CLASS_5_PC_TYPE,
  CLASS_6_PC_TYPE,
  CLASS_7_PC_TYPE,
} from "../../helpers/constants";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          x
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

// TODO: - get all invoices in which the account is mentioned
//       - Helper(accounts,invoice) returns => the EC line of that particular account : [account,debit,credit....]
//       - fetch that data
//       - EXAMPLE: account code : 611
function PlanComptable(props) {
  const [t, i18n] = useTranslation();

  const { organisation } = useContext(OrgContext);

  const [depenseInvoices, setDepenseInvoices] = useState([]);
  const [achatInvocies, setAchatInvocies] = useState([]);
  const [invoices, setInvoices] = useState([]);

  const [accounts, setAccounts] = useState([]);
  const [taxeAccounts, setTaxeAccounts] = useState([]);

  const [currentSelectedStatus, setCurrentSelectedStatus] = useState(0);
  let [newStatus, setNewStatus] = useState(0);
  const [currentSelectedInvoice, setCurrentSelectedInvoice] = useState(0);
  const [paymentType, setPaymentType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [filtredInvoices, setFiltredInvoices] = useState([]);
  const [soldeCloture, setSoldeCloture] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalDebitGlTiers, setTotalDebitGlTiers] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalCreditGlTiers, setTotalCreditGlTiers] = useState(0);

  const [selectedAccountType, setSelectedAccountType] = useState("");
  const [accountCode, setAccountCode] = useState("");
  const [accountDescription, setAccountDescription] = useState("");
  const [accountName, setAccountName] = useState("");
  const [selectedAccountToEdit, setSelectedAccountToEdit] = useState([]);
  const [accountId, setAccountId] = useState(0);
  const [filtredInvoicesExist, setFiltredInvoicesExist] = useState(true);
  //associated invoice to the choosed account
  const [associatedInvoices, setAssociatedInvoices] = useState([]);
  const [accountsGl, setAccountsGl] = useState([]);
  const [invoicesEcs, setInvoicesEcs] = useState([]);
  const [pieces, setPieces] = useState([]);
  const [glTiers, setGlTiers] = useState([]);

  const [isTiers, setIsTiers] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const { onlyComptable } = useAuthHelper();

  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [filterIsValid, setFilterIsValid] = useState(false);
  useEffect(() => {
    onlyComptable();

    $(".some-fields-are-required-to-save").css("display", "none");
    if (organisation.id) {
      fetchTaxeAccounts();
      fetchAccounts();
      getAllInvoices();
      getPieces();
    }
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    if (invoicesEcs.length > 0) {
      setIsTiers(false);
      let solde_debit = 0;
      let solde_credit = 0;

      for (let i = 0; i < invoicesEcs.length; i++) {
        if (invoicesEcs[i].module === "invoice") {
          console.log("iteration no : ", i);
          console.log("total ht: ", parseFloat(invoicesEcs[i].total_ht));
          if (invoicesEcs[i].debit) {
            let sd = Number(invoicesEcs[i].total_ht).toFixed(2);
            solde_debit += parseFloat(sd);
          } else {
            let sd = Number(invoicesEcs[i].total_ht).toFixed(2);
            solde_credit += parseFloat(sd);
          }
        } else {
          solde_debit += parseFloat(invoicesEcs[i].debit);
          solde_credit += parseFloat(invoicesEcs[i].credit);
        }
      }

      setTotalCredit(solde_credit.toFixed(2));

      setTotalDebit(solde_debit.toFixed(2));
      setSoldeCloture(parseFloat(solde_debit) - parseFloat(solde_credit));
    }
  }, [invoicesEcs]);

  useEffect(() => {
    if (glTiers.length > 0) {
      setIsTiers(true);
      let solde_debit = 0;
      let solde_credit = 0;

      for (let i = 0; i < glTiers.length; i++) {
        solde_debit += parseFloat(glTiers[i].totaldebit);
        solde_credit += parseFloat(glTiers[i].totalcredit);
      }
      setTotalCreditGlTiers(solde_credit);
      setTotalDebitGlTiers(solde_debit);
      setSoldeCloture(
        parseFloat(isNaN(solde_debit) ? 0 : solde_debit) -
          parseFloat(isNaN(solde_credit) ? 0 : solde_credit)
      );
      console.log("sssssssssssssss: ,", solde_credit);
    }
  }, [glTiers]);

  const getAllInvoices = async () => {
    const response = await jwtInterceoptor.get(
      `/data/user/factures/getinvoicesforgl/${organisation.id}`
    );

    if (response.status === 200) {
      setInvoices(response.data.data);
      console.log("db invocies : ", response.data.data);
    }
  };

  /**
   *
   * @returns {Promise<void>}
   */
  const getPieces = async () => {
    const response = await jwtInterceoptor.get(
      `/data/user/piece/getallpieces/${organisation.id}`
    );

    if (response.status === 200) {
      setPieces(response.data.data);
      console.log("db invocies : ", response.data.data);
    }
  };

  const fetchAccounts = async () => {
    setLoadingData(true);
    const response = await jwtInterceoptor.get(
      `/data/user/accounts/${organisation.id}`
    );

    if (response.status === 200) {
      //don't include accounts of bq/cs/cli/fourni
      setAccounts(
        response.data.data.filter(
          (account) =>
            account.code !== "34210000" &&
            account.code !== "44110000" &&
            account.code !== "51410000" &&
            account.code !== "51610000"
        )
      );
    }
    setLoadingData(false);
  };

  const fetchTaxeAccounts = async () => {
    const response = await jwtInterceoptor.get(
      `/data/user/accounts/taxe/${organisation.id}`
    );

    if (response.status === 200) {
      response.data.data.map((account) => {
        setTaxeAccounts((taxeAccounts) => [...taxeAccounts, account.code]);
      });
    }
  };

  const deleteItem = async (inv) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await jwtInterceoptor.delete(
          `/data/user/factures/delete/${inv.id}`
        );

        if (response.status === 200) {
          if (response.data.status == true) {
            let invs = invoices.filter((el) => el.id != inv.id);

            setInvoices(invs);

            Swal.fire(
              t("Deleted!"),
              t("Your record has been deleted."),
              "success"
            );

            return;
          }
        }

        Swal.fire({
          icon: "warning",
          title: "",
          text: t("Something went wrong!, try again"),
        });
      }
    });
  };

  const [selectedInv, setSelectedInv] = useState(null);

  /**
   *
   * @param code
   * @return {boolean}
   */
  const isBqSousCompteAndNotBq = (code) => {
    if (code === "51410000") {
      return false;
    }
    return code.substring(0, 4) === "5141";
  };

  /**
   *
   * @param code
   * @return {boolean}
   */
  const isCsSousCompteAndNotBq = (code) => {
    if (code === "51610000") {
      return false;
    }
    return code.substring(0, 4) === "5161";
  };

  const handleFilterDate = () => {
    if (dateDebut === "" || dateFin === "") {
      setFilterIsValid(false);

      toast.warning(t("Merci de remplir tout les champs"), {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else if (dateDebut > dateFin) {
      setFilterIsValid(false);

      toast.warning(
        t("La date de début ne peut pas être supérieure à la date de fin."),
        {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
    } else {
      //handle
      setFilterIsValid(true);
      console.log("filtre:", dateDebut, dateFin);
      toast.success("Le filtre a été appliquer avec succès", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleClearFilter = () => {
    setFilterIsValid(false);
    setDateDebut("");
    setDateFin("");
  };

  const getDetails = (inv, all = false) => {
    setSelectedInv(inv);
    setSoldeCloture(0);
    setTotalCredit(0);
    setTotalDebit(0);
    setInvoicesEcs([]);
    console.log("inv", inv);
    let currentState = [];

    let condition = true;
    let dateFrom = new Date(dateDebut);
    let dateTo = new Date(dateFin);

    if (
      isBqSousCompteAndNotBq(inv.code.toString()) ||
      isCsSousCompteAndNotBq(inv.code.toString())
    ) {
      invoices.map(async (invoice) => {
        for (let i = 0; i < invoice.payment.length; i++) {
          let dateCreatedAt = new Date(invoice.payment[i].created_at);
          if (dateDebut === "" && dateFin === "" && !filterIsValid) {
            condition = true;
          } else {
            condition = dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
          }

          if (
            invoice.payment[i].payment_account != null &&
            invoice.payment[i].payment_account.code === inv.code.toString() &&
            condition
          ) {
            let flux_du_compte = {};

            console.log(
              "invoice: ",
              invoice.type.charAt(0) + "" + invoice.id,
              " payment : ",
              invoice.payment[i]
            );
            let totalHtForEc =
              i === invoice.payment.length - 1 &&
              invoice.payment[i].status.id === 2
                ? invoice.payment[i].rap === null
                  ? invoice.payment[i - 1].rap
                  : invoice.payment[i].rap
                : invoice.payment[i].payed_amount;
            if (invoice.type === "avoir") {
              totalHtForEc = totalHtForEc * -1;
            }

            flux_du_compte = {
              code: inv.code.toString(),
              date_creation: moment(invoice.payment[i].created_at).format(
                "DD/MM/YYYY"
              ),
              no_piece:
                invoice.type === "avoir"
                  ? "FAV" + "" + invoice.id
                  : invoice.type.charAt(0) + "" + invoice.id,
              debit: invoice.type === "vente" || invoice.type === "avoir",
              credit: invoice.type !== "vente" && invoice.type !== "avoir",
              total_ht: totalHtForEc,
              module: "invoice",
              invoice_type: invoice.type,
              libelle: "-",
            };
            setInvoicesEcs((invoicesEcs) => [...invoicesEcs, flux_du_compte]);
            currentState = [...currentState, flux_du_compte];
          }
        }
      });

      pieces.map((piece) => {
        for (let i = 0; i < piece["debit_credit"].length; i++) {
          let dateCreatedAt = new Date(piece.created_at);
          if (dateDebut === "" && dateFin === "" && !filterIsValid) {
            condition = true;
          } else {
            condition = dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
          }

          if (
            piece["debit_credit"][i]["account"] != null &&
            piece["debit_credit"][i]["account"]["code"] ===
              inv.code.toString() &&
            condition
          ) {
            let flux_du_compte = {};
            flux_du_compte = {
              code: inv.code.toString(),
              date_creation: moment(piece.created_at).format("DD/MM/YYYY"),
              no_piece:
                piece.type_facture === null ? "-" : "p" + piece.invoice_id,
              debit: piece["debit_credit"][i]["debit"],
              credit: piece["debit_credit"][i]["credit"],
              total_ht: null,
              invoice_type:
                piece.type_facture === null
                  ? piece.journal
                  : piece.type_facture,
              module: "piece",
              libelle: piece.type_facture === null ? piece.libelle : "-",
            };
            setInvoicesEcs((invoicesEcs) => [...invoicesEcs, flux_du_compte]);
            currentState = [...currentState, flux_du_compte];
          }
        }
      });
    } else if (
      ["34210000", "44110000", "51410000", "51610000"].includes(
        inv.code.toString()
      )
    ) {
      let flux = [];

      if (
        inv.code.toString() === "51410000" ||
        inv.code.toString() === "51610000"
      )
        flux = getBqAccountTotal(
          invoices,
          inv.code.toString(),
          pieces,
          dateFrom,
          dateTo,
          !(dateDebut === "" && dateFin === "" && !filterIsValid)
        );
      else
        flux = getTotalOfAccount(
          invoices,
          inv.code.toString(),
          pieces,
          dateFrom,
          dateTo,
          !(dateDebut === "" && dateFin === "" && !filterIsValid)
        );
      console.log("getBqAccountTotal: ", flux);
      for (let i = 0; i < flux.length; i++) {
        let flux_res = {
          is_gr_tiers: true,
          code: flux[i]["code"],
          date_creation: "",
          no_piece: "",
          debit: flux[i]["totaldebit"],
          credit: flux[i]["totalcredit"],
          total_ht: "",
          module: "invoice",
          invoice_type: "",
          libelle: flux[i]["code"],
        };
        currentState = [...currentState, flux_res];
      }
      setGlTiers(flux);
    } else {
      invoices.map(async (invoice) => {
        if (
          invoice.client.account &&
          invoice.client.account.code === inv.code.toString()
        ) {
          let dateCreatedAt = new Date(invoice.created_at);
          if (dateDebut === "" && dateFin === "" && !filterIsValid) {
            condition = true;
          } else {
            condition = dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
          }

          if (condition) {
            let flux_ec = getEcEcoV2(invoice);
            console.log("flux_ec: ", flux_ec);

            let flux_du_compte_eco = {
              code: inv.code.toString(),
              date_creation: flux_ec.date_creation,
              no_piece: flux_ec.no_piece,
              debit: invoice.type === "vente" || invoice.type === "avoir",
              credit: invoice.type !== "vente" && invoice.type !== "avoir",
              total_ht: flux_ec.total_ttc,
              invoice_type: invoice.type,
              module: "invoice",
              libelle: invoice.client.companyName,
            };
            setInvoicesEcs((invoicesEcs) => [
              ...invoicesEcs,
              flux_du_compte_eco,
            ]);
            currentState = [...currentState, flux_du_compte_eco];
          }

          let flux_fin = getEcFinV2(
            invoice,
            dateFrom,
            dateTo,
            !(dateDebut === "" && dateFin === "" && !filterIsValid)
          );
          console.log("invoice: ", invoice);
          console.log("flux_fin: ", flux_fin);

          if (flux_fin != null && Array.isArray(flux_fin)) {
            for (let i = 0; i < flux_fin.length; i++) {
              var libelle = "";
              libelle =
                flux_fin[i].banquePaymentOption === null
                  ? flux_fin[i].libelle_fournisseur
                  : flux_fin[i].banquePaymentOption +
                    (flux_fin[i].chequeId === null
                      ? ""
                      : " - " + flux_fin[i].chequeId);

              let flux_du_compte_fin = {
                code: inv.code.toString(),
                date_creation: flux_fin[i].date_creation,
                no_piece: flux_fin[i].no_piece,
                debit: invoice.type !== "vente" && invoice.type !== "avoir",
                credit: invoice.type === "vente" || invoice.type === "avoir",
                total_ht: Number(flux_fin[i].total_ttc).toFixed(2),
                invoice_type: invoice.type,
                module: "invoice",
                libelle: libelle,
              };
              setInvoicesEcs((invoicesEcs) => [
                ...invoicesEcs,
                flux_du_compte_fin,
              ]);
              currentState = [...currentState, flux_du_compte_fin];
            }
          }
        }
        if (taxeAccounts.includes(inv.code.toString())) {
          if (invoice.type === "vente" || invoice.type === "avoir") {
            for (let i = 0; i < invoice.products.length; i++) {
              let dateCreatedAt = new Date(invoice.created_at);
              if (dateDebut === "" && dateFin === "" && !filterIsValid) {
                condition = true;
              } else {
                condition =
                  dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
              }

              if (
                invoice.products[i].product.taxe_vente &&
                invoice.products[i].product.taxe_vente.code ===
                  inv.code.toString() &&
                condition
              ) {
                let flux_du_compte = {};
                let total_tva =
                  Number(
                    parseFloat(invoice.products[i].qty) *
                      parseFloat(invoice.products[i].price_unit_ht) *
                      parseFloat(invoice.products[i].tva)
                  ) * (invoice.type === "avoir" ? -1 : 1).toFixed(2);

                flux_du_compte = {
                  code: inv.code.toString(),
                  date_creation: moment(invoice.created_at).format(
                    "DD/MM/YYYY"
                  ),
                  no_piece: invoice.type.charAt(0) + "" + invoice.id,
                  debit: invoice.type !== "vente" && invoice.type !== "avoir",
                  credit: invoice.type === "vente" || invoice.type === "avoir",
                  total_ht: Number(total_tva / 100).toFixed(2),
                  invoice_type: invoice.type,
                  module: "invoice",
                };
                setInvoicesEcs((invoicesEcs) => [
                  ...invoicesEcs,
                  flux_du_compte,
                ]);
                currentState = [...currentState, flux_du_compte];
              }
            }
          } else if (invoice.type === "achat") {
            for (let i = 0; i < invoice.product.length; i++) {
              let dateCreatedAt = new Date(invoice.created_at);
              if (dateDebut === "" && dateFin === "" && !filterIsValid) {
                condition = true;
              } else {
                condition =
                  dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
              }

              if (
                invoice.product[i].product.taxe_achat &&
                invoice.product[i].product.taxe_achat.code ===
                  inv.code.toString() &&
                condition
              ) {
                let flux_du_compte = {};
                let total_tva =
                  Number(
                    parseFloat(invoice.product[i].qty) *
                      parseFloat(invoice.product[i].price_unit_ht)
                  ) * parseFloat(invoice.product[i].tva).toFixed(2);

                flux_du_compte = {
                  code: inv.code.toString(),
                  date_creation: moment(invoice.created_at).format(
                    "DD/MM/YYYY"
                  ),
                  no_piece: invoice.type.charAt(0) + "" + invoice.id,
                  debit: invoice.type !== "vente",
                  credit: invoice.type === "vente",
                  total_ht: Number(total_tva / 100).toFixed(2),
                  invoice_type: invoice.type,
                  module: "invoice",
                };
                setInvoicesEcs((invoicesEcs) => [
                  ...invoicesEcs,
                  flux_du_compte,
                ]);
                currentState = [...currentState, flux_du_compte];
              }
            }
          } else if (invoice.type === "depense") {
            for (let i = 0; i < invoice.accounts.length; i++) {
              let dateCreatedAt = new Date(invoice.created_at);
              if (dateDebut === "" && dateFin === "" && !filterIsValid) {
                condition = true;
              } else {
                condition =
                  dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
              }

              if (
                invoice.accounts[i].tva &&
                invoice.accounts[i].tva.code === inv.code.toString() &&
                condition
              ) {
                let flux_du_compte = {};
                let total_tva = Number(
                  parseFloat(invoice.accounts[i].total_ht) *
                    parseFloat(invoice.accounts[i].tva.rate)
                ).toFixed(2);
                //let total_tva = parseFloat(invoice.accounts[i].total_ttc) * parseFloat(invoice.accounts[i].tva_taux);

                flux_du_compte = {
                  code: inv.code.toString(),
                  date_creation: moment(invoice.created_at).format(
                    "DD/MM/YYYY"
                  ),
                  no_piece: invoice.type.charAt(0) + "" + invoice.id,
                  debit: invoice.type !== "vente",
                  credit: invoice.type === "vente",
                  total_ht: Number(total_tva / 100).toFixed(2),
                  invoice_type: invoice.type,
                  module: "invoice",
                };
                setInvoicesEcs((invoicesEcs) => [
                  ...invoicesEcs,
                  flux_du_compte,
                ]);
                currentState = [...currentState, flux_du_compte];
              }
            }
          }
        }

        // cc normale
        else {
          /**
                     * =true is user has not set a filter (so we take all transaction without any filter

                     * @type {boolean}
                     */
          let condition = true;
          let dateCreatedAt = new Date(invoice.created_at);
          let dateFrom = new Date(dateDebut);
          let dateTo = new Date(dateFin);

          if (invoice.type === "vente" || invoice.type === "avoir") {
            console.log("this is invoice achat: ");
            for (let i = 0; i < invoice.products.length; i++) {
              if (dateDebut === "" && dateFin === "" && !filterIsValid) {
                condition = true;
              } else {
                condition =
                  dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
              }

              if (
                invoice.products[i].product.sales_account.code ===
                  inv.code.toString() &&
                condition
              ) {
                console.log("***********************************");
                console.log("invoice id : ", invoice.id);
                console.log(
                  "invoice total_ht no°",
                  i,
                  " with totl_ht is : ",
                  invoice.products[i].total_ht
                );
                let flux_du_compte = {};
                let total_ttc_account_for_gl = 0;
                let operator = invoice.type === "avoir" ? -1 : 1;

                flux_du_compte = {
                  code: inv.code.toString(),
                  date_creation: moment(invoice.created_at).format(
                    "DD/MM/YYYY"
                  ),
                  no_piece: invoice.type.charAt(0) + "" + invoice.id,
                  debit: invoice.type !== "vente" && invoice.type !== "avoir",
                  credit: invoice.type === "vente" || invoice.type === "avoir",
                  total_ht: invoice.products[i].total_ht * operator,
                  invoice_type: invoice.type,
                  module: "invoice",
                  libelle: "-",
                };
                console.log("flux_du_compte here : ", flux_du_compte);
                setInvoicesEcs((invoicesEcs) => [
                  ...invoicesEcs,
                  flux_du_compte,
                ]);
                currentState = [...currentState, flux_du_compte];
              }
            }
          } else if (invoice.type === "achat") {
            console.log("this is invoice achat: ");
            for (let i = 0; i < invoice.product.length; i++) {
              if (dateDebut === "" && dateFin === "" && !filterIsValid) {
                condition = true;
              } else {
                condition =
                  dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
              }

              if (
                invoice.product[i].product.purchase_account.code ===
                  inv.code.toString() &&
                condition
              ) {
                console.log("***********************************");
                console.log("invoice id : ", invoice.id);
                console.log(
                  "invoice total_ht no°",
                  i,
                  " with totl_ht is : ",
                  invoice.product[i].total_ht
                );
                let flux_du_compte = {};
                let total_ttc_account_for_gl = 0;

                flux_du_compte = {
                  code: inv.code.toString(),
                  date_creation: moment(invoice.created_at).format(
                    "DD/MM/YYYY"
                  ),
                  no_piece: invoice.type.charAt(0) + "" + invoice.id,
                  debit: invoice.type !== "vente",
                  credit: invoice.type === "vente",
                  total_ht: invoice.product[i].total_ht,
                  invoice_type: invoice.type,
                  module: "invoice",
                  libelle: "-",
                };
                console.log("flux_du_compte : ", flux_du_compte);
                setInvoicesEcs((invoicesEcs) => [
                  ...invoicesEcs,
                  flux_du_compte,
                ]);
                currentState = [...currentState, flux_du_compte];
              }
            }
          } else if (invoice.type === "depense") {
            for (let i = 0; i < invoice.accounts.length; i++) {
              if (dateDebut === "" && dateFin === "" && !filterIsValid) {
                condition = true;
              } else {
                condition =
                  dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
              }

              if (
                invoice.accounts[i].account.code === inv.code.toString() &&
                condition
              ) {
                let flux_du_compte = {};
                let total_ttc_account_for_gl = 0;
                flux_du_compte = {
                  code: inv.code.toString(),
                  date_creation: moment(invoice.created_at).format(
                    "DD/MM/YYYY"
                  ),
                  no_piece: invoice.type.charAt(0) + "" + invoice.id,
                  debit: invoice.type !== "vente",
                  credit: invoice.type === "vente",
                  total_ht: invoice.accounts[i].total_ht,
                  invoice_type: invoice.type,
                  module: "invoice",
                  libelle: "-",
                };
                setInvoicesEcs((invoicesEcs) => [
                  ...invoicesEcs,
                  flux_du_compte,
                ]);
                currentState = [...currentState, flux_du_compte];
              }
            }
          }
        }
      });

      pieces.map((piece) => {
        let dateCreatedAt = new Date(piece.created_at);

        for (let i = 0; i < piece["debit_credit"].length; i++) {
          if (dateDebut === "" && dateFin === "" && !filterIsValid) {
            condition = true;
          } else {
            condition = dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
          }

          if (
            piece["debit_credit"][i]["account"]["code"] ===
              inv.code.toString() &&
            condition
          ) {
            let flux_du_compte = {};
            flux_du_compte = {
              code: inv.code.toString(),
              date_creation: moment(piece.created_at).format("DD/MM/YYYY"),
              no_piece:
                piece.type_facture === null ? "-" : "p" + piece.invoice_id,
              debit: piece["debit_credit"][i]["debit"],
              credit: piece["debit_credit"][i]["credit"],
              total_ht: null,
              invoice_type:
                piece.type_facture === null
                  ? piece.journal
                  : piece.type_facture,
              module: "piece",
              libelle: piece.type_facture === null ? piece.libelle : "-",
            };
            setInvoicesEcs((invoicesEcs) => [...invoicesEcs, flux_du_compte]);
            currentState = [...currentState, flux_du_compte];
          }
        }
      });
    }

    setSelectedInv(inv);
    return currentState;
  };

  const formatNumber = (number) => {
    let result = number.toString().padStart(6, "0");
    return result;
  };

  const columns = [
    {
      field: "Code du compte",
      headerName: t("Code du compte"),
      valueGetter: (params) => params.row.code,
      width: 180,
    },
    {
      field: "Nom du compte",
      headerName: t("Nom du compte"),
      valueGetter: (params) => params.row.name,
      width: 180,
    },
    {
      flex: 1,
      field: "Type",
      headerName: t("Type"),
      valueGetter: (params) => params.row.type,
    },
    {
      field: "action",
      headerName: t("ACTIONS"),
      width: 180,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onDelete = (e) => {
          const inv = params.row;
          return deleteItem(inv);
        };

        const onEdit = (e) => {
          const inv = params.row;
          setAccountName(inv.name);
          setAccountDescription(inv.description);
          setAccountCode(inv.code);
          setAccountId(inv.id);
        };

        const details = (e) => {
          const inv = params.row;
          return getDetails(inv);
        };

        /**
         * @param e
         */
        const emailInvoice = async (e) => {
          const inv = params.row;
          console.log(inv);
          const response = await jwtInterceoptor
            .post("/factures/send", inv)
            .then((res) => {
              Swal.fire(
                t("La facture a été envoyer avec succès"),
                t(""),
                "success"
              );
            })
            .catch((error) => console.log(error));
        };
        return (
          <div className="btn-list">
            {/*<button data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={onEdit} id="bEdit" type="button" className="btn  btn-sm btn-primary">
                            <span className="fe fe-edit"> </span>
                        </button>*/}
            <a
              data-bs-toggle="offcanvas"
              href="#offcanvasExample"
              role="button"
              aria-controls="offcanvasExample"
              onClick={details}
              id="bDel"
              type="button"
              className="btn  btn-sm btn-secondary"
            >
              <span className="fe fe-eye"> </span>
            </a>
          </div>
        );
      },
    },
  ];

  const filter = () => {
    if (
      paymentType.length === 1 ||
      paymentType.length === 0 ||
      selectedStatus === "0" ||
      selectedStatus === ""
    ) {
      $(".some-fields-are-required-to-save").css("display", "block");
    } else {
      $(".some-fields-are-required-to-save").css("display", "none");
      let res = invoices.filter(
        (invoice) =>
          invoice.payment_method === paymentType &&
          invoice.status_infos.name === selectedStatus
      );
      setInvoices(res);
      window.$("#staticBackdrop").modal("hide");
    }
  };

  const save = async (event) => {
    if (
      selectedAccountType.length === 0 ||
      selectedAccountType === "0" ||
      accountCode.length === 0 ||
      accountName.length === 0
    ) {
      $(".some-fields-are-required-to-save").css("display", "block");
    } else {
      $(".some-fields-are-required-to-save").css("display", "none");
      const preparedObject = {
        id: accountId,
        name: accountName,
        type: selectedAccountType,
        description: accountDescription,
        code: accountCode,
        organization_id: organisation.id,
      };
      const response = await jwtInterceoptor
        .patch("/data/user/accounts", preparedObject)
        .then((res) => {
          window.$("#exampleModal").modal("hide");
// Correction de la faute d’orthographe
          Swal.fire(t("Le compte a été modifié avec succès."), t(""), "success");
          setAccounts(res.data.data);
        })
        .catch((error) => console.log(error));
    }
  };
  /**
   *
   * @param type
   * @returns {string}
   */
  const getTransactionCj = (type) => {
    if (type === "vente") {
      return "VTE";
    } else if (type === "achat") {
      return "ACH";
    } else if (type === "depense") {
      return "ACH";
    } else if (type === "Operation Diverses") {
      return "OD";
    } else if (type === "Report à Nouveaux") {
      return "RAN";
    } else if (type === "avoir") {
      return "AVOIR";
    }
  };

  // Create styles
  const styles = StyleSheet.create({
    page: {
      // flexDirection: 'row',
      // backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      fontSize: 11,
      //flex: 1,
      // flexGrow: 1,
    },
    header: {
      flexDirection: "row",
      marginBottom: 12,
      borderWidth: 1, // Ensure a valid fallback
    },
    cell: {
      borderRightWidth: 1, // Ensure a valid fallback
      justifyContent: "center",
      alignItems: "center",
      minHeight: 25,
    },
    cellRow: {
      minHeight: 25,
      padding: 5,
      paddingTop: 7,
    },
    textHeader: {
      fontSize: 10,
      fontWeight: "bold",
      textAlign: "center",
    },
    row: {
      flexDirection: "row",
    },
    textRow: {
      fontSize: 9.5,
    },
    headerPage: {
      flexDirection: "row",
      padding: 5,
      borderWidth: 1.5, // Ensure a valid fallback
      marginBottom: 5,
    },
    leftSide: {
      flex: 1,
      fontSize: 9,
      justifyContent: "space-between",
      paddingRight: 20,
    },
    centerContainer: {
      flex: 1,
      justifyContent: "space-between",
      alignItems: "center",
    },
    rightSide: {
      flex: 1,
      fontSize: 9,
      justifyContent: "flex-end",
      paddingLeft: 20,
    },
  });

  const ExportAccount = ({
    data = [],
    data2 = [],
    codeFacture = "",
    subCodeFC = "",
  }) => {
    let date_now = new Date();
    let copyIcon = " © ";
    let solde_progres = 0;
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <View style={[styles.headerPage, { minHeight: 60 }]}>
              <View style={styles.leftSide}>
                <Text>{organisation?.name}</Text>
                <Text>Impression provisoire</Text>
              </View>
              <View style={styles.centerContainer}>
                <Image style={{ width: 40, height: 30 }} src={smalLogo}></Image>
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 16,
                    fontWeight: "bold",
                    marginBottom: 6,
                  }}
                >
                  Grand-livre des comptes
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <Text style={{ marginRight: 30, fontSize: 11.5 }}>
                    {subCodeFC}
                  </Text>
                  <Text style={{ fontSize: 11.5 }}>{codeFacture}</Text>
                </View>
              </View>
              <View style={styles.rightSide}>
                <Text style={{ textAlign: "left", marginRight: 4 }}>
                  Tenue de compte :{" "}
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <Text style={{ textAlign: "left" }}>Période du</Text>
                  <Text style={{ textAlign: "left" }}></Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Text style={{ textAlign: "left" }}>au</Text>
                  <Text style={{ textAlign: "left" }}></Text>
                </View>
              </View>
            </View>
            <View style={{ ...styles.headerPage, border: 0, padding: 0 }}>
              <View style={styles.leftSide}>
                <Text style={{ fontSize: 9 }}>
                  {copyIcon}
                  <Text style={{ htmlContnet: "\\00A9" }}></Text>
                  {"ELMANAGER CLOUD"}
                </Text>
              </View>
              <View style={[{ justifyContent: "flex-end" }]}>
                <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
                  <Text style={{ textAlign: "right", marginRight: 4 }}>
                    Date de tirage :{" "}
                  </Text>
                  <Text style={{ textAlign: "right" }}>
                    {date_now?.getDate()}/{date_now?.getMonth() + 1}/
                    {date_now?.getFullYear()} à {date_now?.getUTCHours() + 1}:
                    {date_now?.getMinutes() < 10
                      ? "0" + date_now?.getMinutes()
                      : date_now?.getMinutes()}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.header}>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>Date</Text>
              </View>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>C.j</Text>
              </View>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>N° pièce</Text>
              </View>
              <View style={[styles.cell, { flex: 3 }]}>
                <Text style={styles.textHeader}>Libellé écriture</Text>
              </View>
              {/* <View style={[styles.cell, {flex: 2}]}><Text style={styles.textHeader}>Let</Text></View> */}
              <View style={[styles.cell, { flex: 3 }]}>
                <Text style={styles.textHeader}>Mouvement débit</Text>
              </View>
              <View style={[styles.cell, { flex: 3 }]}>
                <Text style={styles.textHeader}>Mouvement crédit</Text>
              </View>
              <View style={[styles.cell, { flex: 3, borderRightWidth: 0 }]}>
                <Text style={styles.textHeader}>Solde progressif</Text>
              </View>
            </View>
            <View style={{ border: 1 }}>
              <View style={styles.row}>
                <View style={[styles.cellRow, { flex: 9, paddingRight: 35 }]}>
                  <Text style={styles.textRow}>
                    {selectedInv?.code}
                    <Text>{"      "}</Text> {selectedInv?.name}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text style={[styles.textRow, { textAlign: "right" }]}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text style={[styles.textRow, { textAlign: "right" }]}></Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text style={[styles.textRow, { textAlign: "right" }]}></Text>
                </View>
              </View>

              {data.map((transaction) => {
                if (transaction.module === "invoice") {
                  solde_progres =
                    transaction.debit === true
                      ? solde_progres + parseFloat(transaction.total_ht)
                      : solde_progres - parseFloat(transaction.total_ht);
                  return (
                    <View style={styles.row}>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {transaction?.date_creation}
                        </Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {getTransactionCj(transaction.invoice_type)}
                        </Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {transaction?.no_piece}
                        </Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 3 }]}>
                        <Text style={styles.textRow}>
                          {transaction.libelle}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {transaction.debit === true
                            ? Number(transaction.total_ht).toFixed(2)
                            : ""}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {transaction.credit === true
                            ? Number(transaction.total_ht).toFixed(2)
                            : ""}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(solde_progres).toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  );
                } else {
                  solde_progres += parseFloat(transaction.debit);
                  solde_progres -= parseFloat(transaction.credit);
                  return (
                    <View style={styles.row}>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {transaction?.date_creation}
                        </Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {getTransactionCj(transaction.invoice_type)}
                        </Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 2 }]}>
                        <Text style={styles.textRow}>
                          {transaction?.no_piece}
                        </Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 3 }]}>
                        <Text style={styles.textRow}>
                          {transaction.libelle}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(transaction.debit).toFixed(2)}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(transaction.credit).toFixed(2)}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 3, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(solde_progres).toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  );
                }
              })}
              <View style={styles.row}>
                <View style={[styles.cellRow, { flex: 9, paddingRight: 35 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "center", fontWeight: "bold" },
                    ]}
                  >
                    Total compte {selectedInv?.code}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text style={[styles.textRow, { textAlign: "right" }]}>
                    {Number(totalDebit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text style={[styles.textRow, { textAlign: "right" }]}>
                    {Number(totalCredit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}>
                  <Text style={[styles.textRow, { textAlign: "right" }]}>
                    {Number(totalDebit - totalCredit).toFixed(2)}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  const ExportAllAccount = ({ data = [] }) => {
    let date_now = new Date();
    let copyIcon = " © ";

    let grand_total_debit = 0;
    let grand_total_credit = 0;

    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <View style={{ ...styles.headerPage, minHeight: 60 }}>
              <View style={styles.leftSide}>
                <Text>{organisation?.name}</Text>
                <Text>Impression provisoire</Text>
              </View>
              <View style={styles.centerContainer}>
                <Image
                  style={{ ...styles.image, width: 40, height: 30 }}
                  src={smalLogo}
                ></Image>
                <Text
                  style={{
                    ...styles.textCenter,
                    fontSize: 16,
                    fontWeight: "bold",
                    marginBottom: 6,
                  }}
                >
                  Grand-livre des comptes
                </Text>
              </View>

              {filterIsValid ? (
                <View style={styles.rightSide}>
                  <Text style={{ ...styles.textLeft, marginRight: 4 }}>
                    Tenue de compte :{" "}
                  </Text>
                  <View style={styles.row}>
                    <Text style={{ ...styles.textLeft, flex: 1 }}>
                      Période du
                    </Text>
                    <Text style={{ ...styles.textRight, flex: 1 }}>
                      {moment(dateDebut).format("DD/MM/yyyy")}
                    </Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={{ ...styles.textLeft, flex: 1 }}>au</Text>
                    <Text style={{ ...styles.textRight, flex: 1 }}>
                      {moment(dateFin).format("DD/MM/yyyy")}
                    </Text>
                  </View>
                </View>
              ) : (
                <View style={styles.rightSide}>
                  <Text style={{ ...styles.textLeft, marginRight: 4 }}></Text>
                  <View style={styles.row}>
                    <Text style={{ ...styles.textLeft, flex: 1 }}></Text>
                    <Text style={{ ...styles.textRight, flex: 1 }}></Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={{ ...styles.textLeft, flex: 1 }}></Text>
                    <Text style={{ ...styles.textRight, flex: 1 }}></Text>
                  </View>
                </View>
              )}
            </View>
            <View style={{ ...styles.headerPage, border: 0, padding: 0 }}>
              <View style={styles.leftSide}>
                <Text style={{ ...styles.textSmall, fontSize: 9 }}>
                  {copyIcon}
                  <Text style={{ htmlContnet: "\\00A9" }}></Text>
                  {"ELMANAGER CLOUD"}
                </Text>
              </View>
              <View style={{ ...styles.flexEnd }}>
                <View style={{ ...styles.row, alignItems: "flex-end" }}>
                  <Text style={{ ...styles.textRight, marginRight: 4 }}>
                    Date de tirage :{" "}
                  </Text>
                  <Text style={styles.textRight}>
                    {date_now?.getDate()}/{date_now?.getMonth() + 1}/
                    {date_now?.getFullYear()} à {date_now?.getUTCHours() + 1}:
                    {date_now?.getMinutes() < 10
                      ? "0" + date_now?.getMinutes()
                      : date_now?.getMinutes()}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.header}>
              <View style={{ ...styles.cell, flex: 2 }}>
                <Text style={styles.textHeader}>Date</Text>
              </View>
              <View style={{ ...styles.cell, flex: 2 }}>
                <Text style={styles.textHeader}>C.j</Text>
              </View>
              <View style={{ ...styles.cell, flex: 2 }}>
                <Text style={styles.textHeader}>N° pièce</Text>
              </View>
              <View style={{ ...styles.cell, flex: 3 }}>
                <Text style={styles.textHeader}>Libellé écriture</Text>
              </View>
              <View style={{ ...styles.cell, flex: 3 }}>
                <Text style={styles.textHeader}>Mouvement débit</Text>
              </View>
              <View style={{ ...styles.cell, flex: 3 }}>
                <Text style={styles.textHeader}>Mouvement crédit</Text>
              </View>
              <View style={{ ...styles.cell, flex: 3, borderRightWidth: 1 }}>
                <Text style={styles.textHeader}>Solde progressif</Text>
              </View>
            </View>
            <View style={{ ...styles.border }}>
              {data.map((acct) => {
                let solde_progres = 0;
                let total_debit = 0;
                let total_credit = 0;
                let render = (
                  <>
                    <View style={styles.row}>
                      <View
                        style={{ ...styles.cellRow, flex: 9, paddingRight: 35 }}
                      >
                        <Text style={styles.textRow}>
                          {acct?.acc?.code}
                          <Text>{"      "}</Text> {acct?.acc?.name}
                        </Text>
                      </View>
                      <View
                        style={{
                          ...styles.cellRow,
                          flex: 3,
                          borderLeftWidth: 1,
                        }}
                      >
                        <Text style={{ ...styles.textRight }}></Text>
                      </View>
                      <View
                        style={{
                          ...styles.cellRow,
                          flex: 3,
                          borderLeftWidth: 1,
                        }}
                      >
                        <Text style={{ ...styles.textRight }}></Text>
                      </View>
                      <View
                        style={{
                          ...styles.cellRow,
                          flex: 3,
                          borderLeftWidth: 1,
                        }}
                      >
                        <Text style={{ ...styles.textRight }}></Text>
                      </View>
                    </View>

                    {acct?.data?.map((transaction) => {
                      if (transaction.module === "invoice") {
                        if (
                          transaction.is_gr_tiers != null &&
                          transaction.is_gr_tiers
                        ) {
                          solde_progres +=
                            parseFloat(
                              transaction.debit === "" ? 0 : transaction.debit
                            ) -
                            parseFloat(
                              transaction.credit === "" ? 0 : transaction.credit
                            );
                          total_debit += parseFloat(
                            transaction.debit === "" ? 0 : transaction.debit
                          ).toFixed(2);
                          total_credit += parseFloat(
                            transaction.credit === "" ? 0 : transaction.credit
                          ).toFixed(2);
                        } else {
                          solde_progres =
                            transaction.debit === true
                              ? solde_progres + parseFloat(transaction.total_ht)
                              : solde_progres -
                                parseFloat(transaction.total_ht);
                          total_debit +=
                            transaction.debit === true
                              ? parseFloat(transaction.total_ht)
                              : 0;
                          total_credit +=
                            transaction.credit === true
                              ? parseFloat(transaction.total_ht)
                              : 0;
                        }
                        return (
                          <View style={styles.row}>
                            <View style={{ ...styles.cellRow, flex: 2 }}>
                              <Text style={styles.textRow}>
                                {transaction?.date_creation}
                              </Text>
                            </View>
                            <View style={{ ...styles.cellRow, flex: 2 }}>
                              <Text style={styles.textRow}>
                                {getTransactionCj(transaction.invoice_type)}
                              </Text>
                            </View>
                            <View style={{ ...styles.cellRow, flex: 2 }}>
                              <Text style={styles.textRow}>
                                {transaction?.no_piece}
                              </Text>
                            </View>
                            <View style={{ ...styles.cellRow, flex: 3 }}>
                              <Text style={styles.textRow}>
                                {transaction.libelle}
                              </Text>
                            </View>
                            <View
                              style={{
                                ...styles.cellRow,
                                flex: 3,
                                borderLeftWidth: 1,
                              }}
                            >
                              <Text style={{ ...styles.textRight }}>
                                {transaction.debit === true
                                  ? Number(transaction.total_ht).toFixed(2)
                                  : transaction.is_gr_tiers != null &&
                                    transaction.is_gr_tiers
                                  ? transaction.debit
                                  : "0.00"}
                              </Text>
                            </View>
                            <View
                              style={{
                                ...styles.cellRow,
                                flex: 3,
                                borderLeftWidth: 1,
                              }}
                            >
                              <Text style={{ ...styles.textRight }}>
                                {transaction.credit === true
                                  ? Number(transaction.total_ht).toFixed(2)
                                  : transaction.is_gr_tiers != null &&
                                    transaction.is_gr_tiers
                                  ? transaction.credit
                                  : "0.00"}
                              </Text>
                            </View>
                            <View
                              style={{
                                ...styles.cellRow,
                                flex: 3,
                                borderLeftWidth: 1,
                              }}
                            >
                              <Text style={{ ...styles.textRight }}>
                                {Number(solde_progres).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        );
                      } else {
                        solde_progres += parseFloat(transaction.debit);
                        solde_progres -= parseFloat(transaction.credit);
                        total_debit += parseFloat(transaction.debit);
                        total_credit += parseFloat(transaction.credit);
                        return (
                          <View style={styles.row}>
                            <View style={{ ...styles.cellRow, flex: 2 }}>
                              <Text style={styles.textRow}>
                                {transaction?.date_creation}
                              </Text>
                            </View>
                            <View style={{ ...styles.cellRow, flex: 2 }}>
                              <Text style={styles.textRow}>
                                {getTransactionCj(transaction.invoice_type)}
                              </Text>
                            </View>
                            <View style={{ ...styles.cellRow, flex: 2 }}>
                              <Text style={styles.textRow}>
                                {transaction?.no_piece}
                              </Text>
                            </View>
                            <View style={{ ...styles.cellRow, flex: 3 }}>
                              <Text style={styles.textRow}>
                                {transaction.libelle}
                              </Text>
                            </View>
                            <View
                              style={{
                                ...styles.cellRow,
                                flex: 3,
                                borderLeftWidth: 1,
                              }}
                            >
                              <Text style={{ ...styles.textRight }}>
                                {Number(transaction.debit).toFixed(2)}
                              </Text>
                            </View>
                            <View
                              style={{
                                ...styles.cellRow,
                                flex: 3,
                                borderLeftWidth: 1,
                              }}
                            >
                              <Text style={{ ...styles.textRight }}>
                                {Number(transaction.credit).toFixed(2)}
                              </Text>
                            </View>
                            <View
                              style={{
                                ...styles.cellRow,
                                flex: 3,
                                borderLeftWidth: 1,
                              }}
                            >
                              <Text style={{ ...styles.textRight }}>
                                {Number(solde_progres).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        );
                      }
                    })}
                    <View style={styles.row}>
                      <View
                        style={{ ...styles.cellRow, flex: 9, paddingRight: 35 }}
                      >
                        <Text
                          style={{ ...styles.textCenter, fontWeight: "bold" }}
                        >
                          Total compte {acct?.acc?.code}
                        </Text>
                      </View>
                      <View
                        style={{
                          ...styles.cellRow,
                          flex: 3,
                          borderLeftWidth: 1,
                        }}
                      >
                        <Text
                          style={{ ...styles.textRight, fontWeight: "bold" }}
                        >
                          {Number(total_debit).toFixed(2)}
                        </Text>
                      </View>
                      <View
                        style={{
                          ...styles.cellRow,
                          flex: 3,
                          borderLeftWidth: 1,
                        }}
                      >
                        <Text
                          style={{ ...styles.textRight, fontWeight: "bold" }}
                        >
                          {Number(total_credit).toFixed(2)}
                        </Text>
                      </View>
                      <View
                        style={{
                          ...styles.cellRow,
                          flex: 3,
                          borderLeftWidth: 1,
                        }}
                      >
                        <Text
                          style={{ ...styles.textRight, fontWeight: "bold" }}
                        >
                          {Number(total_debit - total_credit).toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  </>
                );
                grand_total_credit += total_credit;
                grand_total_debit += total_debit;
                return render;
              })}
              <View style={{ ...styles.row, borderTopWidth: 1 }}>
                <View style={{ ...styles.cellRow, flex: 9, paddingRight: 35 }}>
                  <Text style={{ ...styles.textRight, fontWeight: "bold" }}>
                    Totaux
                  </Text>
                </View>
                <View
                  style={{ ...styles.cellRow, flex: 3, borderLeftWidth: 1 }}
                >
                  <Text style={{ ...styles.textRight, fontWeight: "bold" }}>
                    {Number(grand_total_debit).toFixed(2)}
                  </Text>
                </View>
                <View
                  style={{ ...styles.cellRow, flex: 3, borderLeftWidth: 1 }}
                >
                  <Text style={{ ...styles.textRight, fontWeight: "bold" }}>
                    {Number(grand_total_credit).toFixed(2)}
                  </Text>
                </View>
                <View
                  style={{ ...styles.cellRow, flex: 3, borderLeftWidth: 1 }}
                >
                  <Text
                    style={{ ...styles.textRight, fontWeight: "bold" }}
                  ></Text>
                </View>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  const ExportBalanceAccount = ({ data = [] }) => {
    console.log("data is ", data);
    let date_now = new Date();
    let copyIcon = " © ";

    // Totaux Mouvements
    let grand_total_mv_debit = 0;
    let solde_progres_debit = 0;
    let grand_total_mv_credit = 0;
    let solde_progres_credit = 0;

    //total des comptes de bilan
    let total_compte_bilan_debit = 0;
    let total_compte_bilan_credit = 0;

    let total_solde_progres_compte_bilan_debit = 0;
    let total_solde_progres_compte_bilan_credit = 0;

    //total des comptes de gestion
    let total_compte_gestion_debit = 0;
    let total_compte_gestion_credit = 0;

    let total_solde_progres_compte_gestion_debit = 0;
    let total_solde_progres_compte_gestion_credit = 0;

    // Totaux Soldes
    let grand_total_sd_debit = 0;
    let grand_total_sd_credit = 0;

    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <View style={[styles.headerPage, { minHeight: 60 }]}>
              <View style={styles.leftSide}>
                <Text>{organisation?.name}</Text>
                <Text>Impression provisoire</Text>
              </View>
              <View style={styles.centerContainer}>
                <Image style={{ width: 40, height: 30 }} src={smalLogo}></Image>
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 16,
                    fontWeight: "bold",
                    marginBottom: 6,
                  }}
                >
                  Balance des comptes
                </Text>
                <Text style={styles.textRow}>Complète</Text>
              </View>
              {filterIsValid ? (
                <View style={styles.rightSide}>
                  <Text style={{ textAlign: "left", marginRight: 4 }}>
                    Tenue de compte :{" "}
                  </Text>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ textAlign: "left", flex: 1 }}>
                      Période du
                    </Text>
                    <Text
                      style={{
                        textAlign: "right",
                        flex: 1,
                      }}
                    >
                      {moment(dateDebut).format("DD/MM/yyyy")}
                    </Text>
                  </View>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ textAlign: "left", flex: 1 }}>au</Text>
                    <Text
                      style={{
                        textAlign: "right",
                        flex: 1,
                      }}
                    >
                      {moment(dateFin).format("DD/MM/yyyy")}
                    </Text>
                  </View>
                </View>
              ) : (
                <View style={styles.rightSide}>
                  <Text style={{ textAlign: "left", marginRight: 4 }}></Text>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ textAlign: "left", flex: 1 }}></Text>
                    <Text
                      style={{
                        textAlign: "right",
                        flex: 1,
                      }}
                    ></Text>
                  </View>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ textAlign: "left", flex: 1 }}></Text>
                    <Text
                      style={{
                        textAlign: "right",
                        flex: 1,
                      }}
                    ></Text>
                  </View>
                </View>
              )}
            </View>
            <View style={[styles.headerPage, { border: 0, padding: 0 }]}>
              <View style={styles.leftSide}>
                <Text style={{ fontSize: 9 }}>
                  {copyIcon}
                  <Text style={{ htmlContnet: "\\00A9" }}></Text>
                  {"ELMANAGER CLOUD"}
                </Text>
              </View>
              <View style={[{ justifyContent: "flex-end" }]}>
                <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
                  <Text style={{ textAlign: "right", marginRight: 4 }}>
                    Date de tirage :{" "}
                  </Text>
                  <Text style={{ textAlign: "right" }}>
                    {date_now?.getDate()}/{date_now?.getMonth() + 1}/
                    {date_now?.getFullYear()} à {date_now?.getUTCHours() + 1}:
                    {date_now?.getMinutes() < 10
                      ? "0" + date_now?.getMinutes()
                      : date_now?.getMinutes()}
                  </Text>
                </View>
              </View>
            </View>
            <View style={[styles.header, { height: 50 }]}>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>Numéro de compte</Text>
              </View>
              <View style={[styles.cell, { flex: 4 }]}>
                <Text style={styles.textHeader}>Intitulé des comptes</Text>
              </View>
              <View style={[{ flex: 4, borderRight: 1 }]}>
                <Text style={[styles.textHeader, { marginTop: 10 }]}>
                  Mouvements
                </Text>
                <View
                  style={{ flexDirection: "row", flex: 1, paddingVertical: 5 }}
                >
                  <View style={{ flex: 1 }}>
                    <Text style={styles.textHeader}>Débit</Text>
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text style={styles.textHeader}>Crédit</Text>
                  </View>
                </View>
              </View>
              <View style={[{ flex: 4 }]}>
                <Text style={[styles.textHeader, { marginTop: 10 }]}>
                  Soldes
                </Text>
                <View
                  style={{ flexDirection: "row", flex: 1, paddingVertical: 5 }}
                >
                  <View style={{ flex: 1 }}>
                    <Text style={styles.textHeader}>Débit</Text>
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text style={styles.textHeader}>Crédit</Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={{ border: 1 }}>
              {data.map((acct) => {
                let accountType = acct.acc.type;
                let solde_progres = 0;
                let total_debit = 0;
                let total_credit = 0;

                let totalCompteBilanDebit = 0;
                let totalCompteBilanCredit = 0;
                let totalCompteGestionDebit = 0;
                let totalCompteGestionCredit = 0;

                let render = (
                  <>
                    {acct?.data?.map((transaction) => {
                      console.log("transaction ", transaction);

                      if (transaction.is_gr_tiers) {
                        if (transaction.module === "invoice") {
                          //solde_progres = transaction.debit === true ? solde_progres + transaction.total_ht : solde_progres - transaction.total_ht;
                          total_debit += transaction.debit;
                          total_credit += transaction.credit;
                        } else {
                          //solde_progres += transaction.debit;
                          //solde_progres -= transaction.credit;
                          total_debit += parseFloat(transaction.debit);
                          total_credit += parseFloat(transaction.credit);
                        }
                      } else {
                        if (transaction.module === "invoice") {
                          //solde_progres = transaction.debit === true ? solde_progres + transaction.total_ht : solde_progres - transaction.total_ht;
                          total_debit +=
                            transaction.debit === true
                              ? parseFloat(transaction.total_ht)
                              : 0;
                          total_credit +=
                            transaction.credit === true
                              ? parseFloat(transaction.total_ht)
                              : 0;
                        } else {
                          //solde_progres += transaction.debit;
                          //solde_progres -= transaction.credit;
                          total_debit += parseFloat(transaction.debit);
                          total_credit += parseFloat(transaction.credit);
                        }
                      }
                    })}

                    <View style={styles.row}>
                      <View
                        style={[styles.cellRow, { flex: 2, paddingRight: 20 }]}
                      >
                        <Text style={styles.textRow}>{acct?.acc?.code}</Text>
                      </View>
                      <View style={[styles.cellRow, { flex: 4 }]}>
                        <Text style={[styles.textRow, { textAlign: "left" }]}>
                          {acct?.acc?.name}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 2, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {total_debit > 0
                            ? Number(total_debit).toFixed(2)
                            : null}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 2, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {total_credit > 0
                            ? Number(total_credit).toFixed(2)
                            : null}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 2, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {total_debit - total_credit > 0
                            ? Number(total_debit - total_credit).toFixed(2)
                            : "0.00"}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.cellRow,
                          { flex: 2, borderLeftWidth: 1 },
                        ]}
                      >
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {total_debit - total_credit < 0
                            ? Number((total_debit - total_credit) * -1).toFixed(
                                2
                              )
                            : "0.00"}
                        </Text>
                      </View>
                    </View>
                  </>
                );

                grand_total_mv_credit += total_credit;
                grand_total_mv_debit += total_debit;

                if (
                  [
                    CLASS_1_PC_TYPE,
                    CLASS_2_PC_TYPE,
                    CLASS_3_PC_TYPE,
                    CLASS_4_PC_TYPE,
                    CLASS_5_PC_TYPE,
                  ].includes(accountType)
                ) {
                  totalCompteBilanDebit += total_debit;
                  totalCompteBilanCredit += total_credit;
                } else if (
                  [CLASS_6_PC_TYPE, CLASS_7_PC_TYPE].includes(accountType)
                ) {
                  totalCompteGestionDebit += total_debit;
                  totalCompteGestionCredit += total_credit;
                }

                total_compte_bilan_debit += totalCompteBilanDebit;
                total_compte_bilan_credit += totalCompteBilanCredit;

                total_compte_gestion_debit += totalCompteGestionDebit;
                total_compte_gestion_credit += totalCompteGestionCredit;

                if (total_debit - total_credit > 0) {
                  solde_progres_credit += 0;
                  solde_progres_debit += total_debit - total_credit;
                } else {
                  solde_progres_debit += 0;
                  solde_progres_credit += (total_debit - total_credit) * -1;
                }

                if (totalCompteBilanDebit - totalCompteBilanCredit > 0) {
                  total_solde_progres_compte_bilan_credit += 0;
                  total_solde_progres_compte_bilan_debit +=
                    totalCompteBilanDebit - totalCompteBilanCredit;
                } else {
                  total_solde_progres_compte_bilan_debit += 0;
                  total_solde_progres_compte_bilan_credit +=
                    (totalCompteBilanDebit - totalCompteBilanCredit) * -1;
                }

                if (totalCompteGestionDebit - totalCompteGestionCredit > 0) {
                  total_solde_progres_compte_gestion_credit += 0;
                  total_solde_progres_compte_gestion_debit +=
                    totalCompteGestionDebit - totalCompteGestionCredit;
                } else {
                  total_solde_progres_compte_gestion_debit += 0;
                  total_solde_progres_compte_gestion_credit +=
                    (totalCompteGestionDebit - totalCompteGestionCredit) * -1;
                }

                // if (total_compte_bilan_debit - total_compte_bilan_credit > 0) {
                //     total_solde_progres_compte_bilan_credit = 0;
                //     total_solde_progres_compte_bilan_debit = (total_compte_bilan_debit - total_compte_bilan_credit);
                // } else {
                //     total_solde_progres_compte_bilan_debit = 0;
                //     total_solde_progres_compte_bilan_credit = (total_compte_bilan_debit - total_compte_bilan_credit) * -1;
                // }
                //
                // if (total_compte_gestion_debit - total_compte_gestion_credit > 0) {
                //     total_solde_progres_compte_gestion_credit = 0;
                //     total_solde_progres_compte_gestion_debit = (total_compte_gestion_debit - total_compte_gestion_credit);
                // } else {
                //     total_solde_progres_compte_gestion_debit = 0;
                //     total_solde_progres_compte_gestion_credit = (total_compte_gestion_debit - total_compte_gestion_credit) * -1;
                // }

                return render;
              })}
              <View style={[styles.row, { borderTopWidth: 1 }]}>
                <View style={[styles.cellRow, { flex: 6, paddingRight: 30 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    Totaux
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(grand_total_mv_debit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(grand_total_mv_credit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      grand_total_mv_debit - grand_total_mv_credit
                    ).toFixed(2) > 0
                      ? Number(
                          grand_total_mv_debit - grand_total_mv_credit
                        ).toFixed(2)
                      : "0.00"}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      grand_total_mv_debit - grand_total_mv_credit
                    ).toFixed(2) > 0
                      ? "0.00"
                      : (
                          Number(
                            grand_total_mv_debit - grand_total_mv_credit
                          ).toFixed(2) * -1
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
              <View style={[styles.row, { borderTopWidth: 1 }]}>
                <View style={[styles.cellRow, { flex: 6, paddingRight: 30 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    Totaux comptes de bilan
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(total_compte_bilan_debit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(total_compte_bilan_credit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      total_compte_bilan_debit - total_compte_bilan_credit
                    ).toFixed(2) > 0
                      ? Number(
                          total_compte_bilan_debit - total_compte_bilan_credit
                        ).toFixed(2)
                      : "0.00"}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      total_compte_bilan_debit - total_compte_bilan_credit
                    ).toFixed(2) > 0
                      ? "0.00"
                      : (
                          Number(
                            total_compte_bilan_debit - total_compte_bilan_credit
                          ).toFixed(2) * -1
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
              <View style={[styles.row, { borderTopWidth: 1 }]}>
                <View style={[styles.cellRow, { flex: 6, paddingRight: 30 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    Totaux comptes de gestion
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(total_compte_gestion_debit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(total_compte_gestion_credit).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      total_compte_gestion_debit - total_compte_gestion_credit
                    ).toFixed(2) > 0
                      ? Number(
                          total_compte_gestion_debit -
                            total_compte_gestion_credit
                        ).toFixed(2)
                      : "0.00"}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      total_compte_gestion_debit - total_compte_gestion_credit
                    ).toFixed(2) > 0
                      ? "0.00"
                      : (
                          Number(
                            total_compte_gestion_debit -
                              total_compte_gestion_credit
                          ).toFixed(2) * -1
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
              <View style={[styles.row, { borderTopWidth: 1 }]}>
                <View style={[styles.cellRow, { flex: 6, paddingRight: 30 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    Totaux de la balance
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      total_compte_bilan_debit + total_compte_gestion_debit
                    ).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      total_compte_bilan_credit + total_compte_gestion_credit
                    ).toFixed(2)}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      total_compte_bilan_debit +
                        total_compte_gestion_debit -
                        (total_compte_bilan_credit +
                          total_compte_gestion_credit)
                    ).toFixed(2) > 0
                      ? Number(
                          total_compte_bilan_debit +
                            total_compte_gestion_debit -
                            (total_compte_bilan_credit +
                              total_compte_gestion_credit)
                        ).toFixed(2)
                      : "0.00"}
                  </Text>
                </View>
                <View style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}>
                  <Text
                    style={[
                      styles.textRow,
                      { textAlign: "right", fontWeight: "bold" },
                    ]}
                  >
                    {Number(
                      total_compte_bilan_debit +
                        total_compte_gestion_debit -
                        (total_compte_bilan_credit +
                          total_compte_gestion_credit)
                    ).toFixed(2) > 0
                      ? "0.00"
                      : (
                          Number(
                            total_compte_bilan_debit +
                              total_compte_gestion_debit -
                              (total_compte_bilan_credit +
                                total_compte_gestion_credit)
                          ).toFixed(2) * -1
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  // Grand livre
  const [selectedAccounts, setSelectedAcounts] = useState([]);
  const [proccesing, setProccessing] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [allAcountsSelected, setAllAcountsSelected] = useState([]);

  // Balance
  const [proccesingBL, setProccessingBL] = useState(false);
  const [loadedBL, setLoadedBL] = useState(false);
  const [allAcountsSelectedBL, setAllAcountsSelectedBL] = useState([]);

  const exportAllAcounts = async () => {
    setProccessing(true);
    setLoaded(false);

    const id = toast.loading("Chargement....", {
      position: "top-right",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      draggable: true,
      progress: undefined,
      theme: "light",
      autoClose: 50,
    });

    try {
      const promises = selectedAccounts.map(async (acc) => {
        try {
          let data_inv = await getDetails(acc, true);
          if (data_inv && data_inv.length > 0) {
            return {
              acc,
              data: data_inv,
            };
          }
          return null; // Retourner null si aucune donnée n'est trouvée
        } catch (error) {
          console.error("Error fetching details for account:", acc, error);
          return null; // Retourner null en cas d'erreur de récupération
        }
      });

      const allAcounts = (await Promise.all(promises)).filter(
        (x) => x !== null
      );

      if (allAcounts.length > 0) {
        toast.update(id, {
          render: "Chargement du grand livre a été fait avec succès.",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
        window.$("#modalExportAccounts").modal("show");
        setAllAcountsSelected(allAcounts);
      } else {
        toast.update(id, {
          render: "Aucune transaction enregistrée.",
          type: "warning",
          isLoading: false,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error in exportAllAcounts:", error);
      toast.update(id, {
        render: "Une erreur est survenue.",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }

    setProccessing(false);
    setLoaded(true);
  };

  const exportBalanceAcounts = async () => {
    setProccessingBL(true);
    setLoadedBL(false);
    window.$("#modalExportBLAccounts").modal("show");

    try {
      // Créez un tableau de promesses pour les comptes sélectionnés
      const promises = selectedAccounts.map(async (acc) => {
        try {
          console.log("acc", acc);
          const data_inv = await getDetails(acc, true);
          console.log("data_inv", data_inv);
          if (data_inv && data_inv.length > 0) {
            return {
              acc,
              data: data_inv,
            };
          }
          return null; // Retourner null si aucune donnée n'est trouvée
        } catch (error) {
          console.error("Error fetching details for account:", acc, error);
          return null; // Retourner null en cas d'erreur de récupération
        }
      });

      // Attendez que toutes les promesses soient résolues
      const allAcounts = (await Promise.all(promises)).filter(
        (x) => x !== null
      );

      setProccessingBL(false);
      setLoadedBL(true);

      if (allAcounts.length > 0) {
        setAllAcountsSelectedBL(allAcounts);
      } else {
        console.warn(
          "Aucune transaction enregistrée pour les comptes sélectionnés."
        );
      }
    } catch (error) {
      console.error("Error in exportBalanceAcounts:", error);
      // Afficher un message d'erreur à l'utilisateur, si nécessaire
    }
  };

  const exportCsvGl = () => {
    exportGlCsv(allAcountsSelected);
  };

  const exportCsvBalance = () => {
    exportBalanceAccountsCsv(allAcountsSelectedBL);
  };

  return (
    <>
      <ToastContainer />

      {/*offcanvas of details*/}
      <div className="row" style={{ zIndex: 1 }}>
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Modifier le compte
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div
                    className="alert alert-danger alert-dismissible fade show mb-0 some-fields-are-required-to-save"
                    role="alert"
                  >
                    <span className="alert-inner--icon">
                      <i className="fe fe-slash"></i>
                    </span>
                    <span className="alert-inner--text">
                      <strong></strong>Attention ! Les champs suivants sont
                      obligatoire.
                    </span>
                    <p>
                      - le nom du compte <br />
                      - Le code du compte <br />
                      - le type du compte <br />
                    </p>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>

                  <br />
                  <br />

                  <label htmlFor="exampleInputEmail1" className="">
                    Type de compte*
                  </label>
                  <select
                    className="form-select"
                    id="buyPriceAccountInput"
                    onChange={(e) => setSelectedAccountType(e.target.value)}
                    value={selectedAccountType}
                  >
                    <option value="0">selectionner un type de compte</option>
                    <option value="Autre actif courant">
                      Autre actif courant
                    </option>
                    <option value="Espèces">Espèces</option>
                    <option value="Comptes clients">Comptes clients</option>
                    <option value="Actif fixe">Actif fixe</option>
                    <option value="Autres engagements à court terme">
                      Autres engagements à court terme
                    </option>
                    <option value="Comptes fournisseurs">
                      Comptes fournisseurs
                    </option>
                    <option value="Autres engagements">
                      Autres engagements
                    </option>
                    <option value="Capitaux">Capitaux</option>
                    <option value="Revenus">Revenus</option>
                    <option value="Dépenses">Dépenses</option>
                    <option value="Coût des marchandises vendues">
                      Coût des marchandises vendues
                    </option>
                    <option value="Autres dépenses">Autres dépenses</option>
                    <option value="Stock">Stock</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    Nom du compte*
                  </label>
                  <input
                    type="text"
                    placeholder="nom"
                    className={`form-control `}
                    onChange={(e) => setAccountName(e.target.value)}
                    value={accountName}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    Description du compte
                  </label>
                  <input
                    type="text"
                    placeholder="description"
                    className={`form-control `}
                    onChange={(e) => setAccountDescription(e.target.value)}
                    value={accountDescription}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    Code du compte*
                  </label>
                  <input
                    type="text"
                    placeholder="code"
                    className={`form-control `}
                    onChange={(e) => setAccountCode(e.target.value)}
                    value={accountCode}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={save}
                >
                  Enregistrer
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="offcanvas offcanvas-start"
          tabIndex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasExampleLabel">
              Details du compte
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="fe fe-x fs-18"></i>
            </button>
          </div>
          <div className="offcanvas-body">
            <div>
              <h1>
                <strong>SOLDE DU COMPTE</strong>
              </h1>
              {/* <div className='d-flex flex-row-reverse'>
                                <PDFDownloadLink
                                    document={<ExportAccount data={[...invoicesEcs]} />}
                                    fileName="grande-livre.pdf"
                                    className='btn btn-info'
                                    style={{height: 38}}
                                >

                                    {({ blob, url, loading, error }) =>
                                    loading ? t("Loading document...") : <><span className="fe fe-download"> </span> {t("Exporter")}</>
                                    }
                                 </PDFDownloadLink>
                            </div> */}
              <br />
              <table className="table">
                <thead className={"tableHeader"}>
                  <tr>
                    <th>Débit</th>
                    <th>Crédit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {soldeCloture < 0
                        ? "0.00"
                        : Number(soldeCloture).toFixed(2)}
                    </td>
                    <td>
                      {soldeCloture < 0
                        ? Number(Math.abs(soldeCloture)).toFixed(2)
                        : "0.00"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <br />
            <div>
              <div
                className="grlSection"
                style={{ display: isTiers === true ? "none" : "block" }}
              >
                <h1>
                  <strong>Transactions récentes</strong>
                </h1>
                <table className="table">
                  <thead className={"tableHeader"}>
                    <tr>
                      <th scope="col">CODE</th>
                      <th scope="col">Date de Facture</th>
                      <th scope="col">C.J</th>
                      <th scope="col">N° PIÉCE</th>
                      <th scope="col">LIBELLE</th>
                      <th scope="col">DÉBIT</th>
                      <th scope="col">CRÉDIT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoicesEcs.map((transaction, index) => {
                      if (transaction.module === "invoice") {
                        return (
                          <tr key={index}>
                            <td>{transaction.code}</td>
                            <td>{transaction.date_creation}</td>
                            <td>
                              {getTransactionCj(transaction.invoice_type)}
                            </td>
                            <td>{transaction.no_piece}</td>
                            <td>{transaction.libelle}</td>
                            <td>
                              {transaction.debit === true
                                ? Number(transaction.total_ht).toFixed(2)
                                : ""}
                            </td>
                            <td>
                              {transaction.credit === true
                                ? Number(transaction.total_ht).toFixed(2)
                                : ""}
                            </td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr>
                            <td>{transaction.code}</td>
                            <td>{transaction.date_creation}</td>
                            <td>
                              {getTransactionCj(transaction.invoice_type)}
                            </td>
                            <td>{transaction.no_piece}</td>
                            <td>{transaction.libelle}</td>
                            <td>{Number(transaction.debit).toFixed(2)}</td>
                            <td>{Number(transaction.credit).toFixed(2)}</td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={3}>Total Mouvement</td>
                      <td>{Number(totalDebit).toFixed(2)}</td>
                      <td>{Number(totalCredit).toFixed(2)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div
                className="grlTiersSection"
                style={{ display: isTiers === true ? "block" : "none" }}
              >
                <table className="table">
                  <thead className={"tableHeader"}>
                    <tr>
                      <th scope="col">CODE</th>
                      <th scope="col">DÉBIT</th>
                      <th scope="col">CRÉDIT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {glTiers.map((transaction) => {
                      return (
                        <tr>
                          <td>{transaction.code}</td>
                          <td>
                            {transaction.totaldebit > 0
                              ? Number(transaction.totaldebit).toFixed(2)
                              : ""}
                          </td>
                          <td>
                            {transaction.totalcredit > 0
                              ? Number(transaction.totalcredit).toFixed(2)
                              : ""}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>Total Mouvement</td>
                      <td>
                        {isNaN(totalDebitGlTiers)
                          ? 0
                          : Number(totalDebitGlTiers).toFixed(2)}
                      </td>
                      <td>
                        {isNaN(totalCreditGlTiers)
                          ? 0
                          : Number(totalCreditGlTiers).toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
        {/*offcanvas of details : end*/}

        <div
          className="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Filtrer votre trésorerie
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div
                  className="alert alert-danger alert-dismissible fade show mb-0 some-fields-are-required-to-save"
                  role="alert"
                >
                  <span className="alert-inner--icon">
                    <i className="fe fe-slash"></i>
                  </span>
                  <span className="alert-inner--text">
                    <strong></strong>Attention ! Les champs suivants sont
                    obligatoire.
                  </span>
                  <p>
                    - L'état de la factrue <br />
                    - Mode de réglement <br />
                  </p>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <br />
                <br />

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    Banque ou Caisse*
                  </label>
                  <select
                    className="form-select"
                    id="buyPriceAccountInput"
                    onChange={(e) => setPaymentType(e.target.value)}
                    value={paymentType}
                  >
                    <option value="0">selectionner un mode de réglement</option>
                    <option value="banque">banque</option>
                    <option value="caisse">caisse</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    Etat*
                  </label>
                  <select
                    className="form-select"
                    id="buyPriceAccountInput"
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    value={selectedStatus}
                  >
                    <option value="0">
                      selectionner l'état des factures à afficher
                    </option>
                    <option value="Payé">Payé</option>
                    <option value="Non Payé">Non Payé</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => filter()}
                >
                  Enregistrer
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Export account modal */}
        <div
          className="modal fade show"
          id="modalExportAccounts"
          aria-modal="true"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered text-center "
            role="document"
          >
            <div className="modal-content tx-size-sm">
              {proccesing ? (
                <div className="modal-body text-center p-4 pb-5">
                  <i className="icon icon-clock fs-70 text-warning lh-1 my-5 d-inline-block"></i>
                  <h4 className="text-warning tx-semibold">
                    {t("Traitement en cours!")}
                  </h4>
                  <p className="mg-b-20 mg-x-20">
                    {t("Patientez s'il-vous-plait")}
                  </p>
                </div>
              ) : null}
              {loaded ? (
                <div className="modal-body text-center p-4 pb-5">
                  <i className="icon icon-check fs-70 text-success lh-1 my-5 d-inline-block"></i>
                  <h4 className="text-success tx-semibold">
                    {t("Généré avec succès!")}
                  </h4>

                  <PDFDownloadLink
                    document={
                      <ExportAllAccount data={[...allAcountsSelected]} />
                    }
                    fileName="Grande-livre.pdf"
                    className="btn btn-success pd-x-25"
                    style={{ height: 38 }}
                    onClick={() => console.log("export ...")}
                  >
                    {({ blob, url, loading, error }) => {
                      if (error) console.log(error);
                      return loading
                        ? t("Loading document...")
                        : t("Télécharger PDF");
                    }}
                  </PDFDownloadLink>

                  <br />
                  <br />
                  <button
                    onClick={exportCsvGl}
                    className={"btn btn-success pd-x-25"}
                    style={{ height: 38 }}
                  >
                    <span>{t("Télécharger CSV")}</span>
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {/* Export balance account modal */}
        <div
          className="modal fade show"
          id="modalExportBLAccounts"
          aria-modal="true"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered text-center "
            role="document"
          >
            <div className="modal-content tx-size-sm">
              {proccesingBL ? (
                <div className="modal-body text-center p-4 pb-5">
                  <i className="icon icon-clock fs-70 text-warning lh-1 my-5 d-inline-block"></i>
                  <h4 className="text-warning tx-semibold">
                    {t("Traitement en cours!")}
                  </h4>
                  <p className="mg-b-20 mg-x-20">
                    {t("Patientez s'il-vous-plait")}
                  </p>
                </div>
              ) : null}
              {loadedBL ? (
                <div className="modal-body text-center p-4 pb-5">
                  <i className="icon icon-check fs-70 text-success lh-1 my-5 d-inline-block"></i>
                  <h4 className="text-success tx-semibold">
                    {t("Balance des comptes a été Généré avec succès!")}
                  </h4>

                  <PDFDownloadLink
                    document={
                      <ExportBalanceAccount data={[...allAcountsSelectedBL]} />
                    }
                    fileName="Balance-des-comptes.pdf"
                    className="btn btn-success pd-x-25"
                    style={{ height: 38 }}
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? t("Loading document...") : t("Télécharger PDF")
                    }
                  </PDFDownloadLink>
                  <br />
                  <br />
                  <button
                    onClick={exportCsvBalance}
                    className="btn btn-success pd-x-25"
                    style={{ height: 38 }}
                  >
                    {t("Télécharger CSV")}
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="page-header">
            <h1 className="page-title breadcumpsHeader">Plan Comptable</h1>
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0)">Complable</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Plan Comptable
                </li>
              </ol>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 p-5 text-right">
                  <div className="col-6 mx-4">
                    <label htmlFor="dateDebut">{t("Date de début")}:</label>
                    <input
                      type="date"
                      className="form-control"
                      id="dateDebut"
                      value={dateDebut}
                      onChange={(e) => setDateDebut(e.target.value)}
                    />
                  </div>
                  <div className="col-6 mx-4 mt-2">
                    <label htmlFor="dateFin">{t("Date de fin")}:</label>
                    <input
                      type="date"
                      className="form-control"
                      id="dateFin"
                      value={dateFin}
                      onChange={(e) => setDateFin(e.target.value)}
                    />
                  </div>
                  <div className="col-6 ">
                    <button
                      className="btn btn-primary mt-5 mx-4"
                      onClick={handleFilterDate}
                    >
                      <i className="fa fa-filter"></i>
                      {t(" Appliquer le filtre")}
                    </button>

                    <button
                      className="btn btn-primary mt-5 mx-4"
                      onClick={() => {
                        navigate("/plancomptable/add");
                      }}
                    >
                      Ajouter un compte comptable
                    </button>
                  </div>
                  {dateDebut !== "" && dateFin !== "" ? (
                    <div className="col-6">
                      <button
                        className="btn btn-danger mt-5 mx-4"
                        onClick={handleClearFilter}
                      >
                        <i className="fa fa-filter"></i>
                        {t(" Vider le filtre")}
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>

              {selectedAccounts.length > 0 ? (
                <div className="custom-export-btn">
                  <div>
                    <button
                      onClick={exportAllAcounts}
                      className="btn btn-primary"
                    >
                      <i className="fa fa-download"></i> Exporter le grand livre
                      des comptes
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={exportBalanceAcounts}
                      className="btn btn-primary"
                    >
                      <i className="fa fa-download"></i> Exporter la balance des
                      comptes
                    </button>
                  </div>
                </div>
              ) : null}
              <div className="table-responsive">
                <div style={{ height: 600, width: "100%" }}>
                  <DataGrid
                    rows={accounts}
                    columns={columns}
                    pagination={false}
                    checkboxSelection
                    onRowSelectionModelChange={(ids) => {
                      console.log("ids", ids);
                      const selectedIDs = new Set(ids);
                      const selectedRowData = accounts.filter((row) =>
                        selectedIDs.has(row.id)
                      );
                      console.log(selectedRowData);
                      setSelectedAcounts(selectedRowData);
                    }}
                    slotProps={{
                      toolbar: {
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                      },
                    }}
                    localeText={
                      i18n.language == "fr"
                        ? frFR.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    slots={{
                      toolbar: GridToolbar,
                      loadingOverlay: LinearProgress,
                    }}
                    loading={loadingData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PlanComptable;
